// import React, { useState } from 'react';
// import { Button, Stack } from 'react-bootstrap';
// import VideoMenuUnderlay from './VideoMenuUnderlay';

// export default function VideoMenuBinder({ initial_scene, loops, transitions, buttons }) {
//   const [scene, setScene] = useState(initial_scene || Object.keys(loops || {})[0] || '');

//   const clips = { loops: loops || {}, transitions: transitions || {} };

//   return (
//     <>
//       <VideoMenuUnderlay scene={scene} clips={clips} />
//       <div className="position-relative p-3" style={{ zIndex: 1 }}>
//         <Stack direction="horizontal" gap={2} className="flex-wrap">
//           {(buttons || []).map((b, i) => (
//             <Button key={i} variant={b.variant || 'primary'} onClick={() => setScene(b.targetScene)}>
//               {b.label}
//             </Button>
//           ))}
//         </Stack>
//       </div>
//     </>
//   );
// }

import { useNavigate, useLocation } from 'react-router-dom';

// VideoMenuBinder.jsx
import React, { useEffect, useRef, useState } from 'react';
import { Button, Stack } from 'react-bootstrap';
import VideoMenuUnderlay from './VideoMenuUnderlay';
import { Container, Row, Col, Card } from 'react-bootstrap';

export default function VideoMenuBinder({
  initial_scene,
  loops,
  transitions,
  buttons,
   displayStyle = 'square', // 'square' | 'rectangle'
  style,                       // e.g., { width: 640 }
  className,
  showControls = true
}) {

const [debugInfo, setDebugInfo] = useState(null);

  const [scene, setScene] = useState(initial_scene || Object.keys(loops || {})[0] || '');
  const clips = { loops: loops || {}, transitions: transitions || {} };

  const wrapRef = useRef(null);
  const [boxH, setBoxH] = useState(0);

  const navigate = useNavigate();
  const location = useLocation();
  // SPINNER BEGIN
  // INSERT NEAR THE TOP OF THE COMPONENT:
  const [spinVisible, setSpinVisible] = useState(false);
  const [spinAnchor, setSpinAnchor] = useState(null); // {left, top} in viewport
  const SPINNER_SRC = '/spinner.png'; // <-- set your PNG path
  const SPINNER_SIZE = 64;

  const showSpinner = (el) => {
    try {
      const r = el?.getBoundingClientRect?.();
      if (r) setSpinAnchor({ left: r.left + r.width / 2, top: r.top + r.height / 2 });
      else setSpinAnchor(null);
    } catch { setSpinAnchor(null); }
    setSpinVisible(true);
  };


  useEffect(() => {
    // strip leading `/` and take first segment as the scene
    const path = location.pathname.replace(/^\/+/, '');
    const segment = path.split('/')[0];

    const fallback = initial_scene || Object.keys(loops || {})[0] || '';
    const nextScene = segment || fallback;

    //setScene(nextScene);
    if (spinVisible == false)
    {
      showSpinner(null); 
      setScene(nextScene);
      //navigate('/'+b.targetScene)
    }


  }, [location.pathname, initial_scene, loops]);

  const hideSpinner = () => { setSpinVisible(false); setSpinAnchor(null); };

  // SPINNER END

  useEffect(() => { // If you home doesnt match
    if (!debugInfo || debugInfo.inTransit) {
      return;
    }

    const path = location.pathname.replace(/^\/+/, '');
    const segment = path.split('/')[0];

    // only react if route points to a known scene and differs from current video location
    if (!segment || !clips.loops?.[segment]) {
      return;
    }

    if (segment !== debugInfo.currentLocation && !spinVisible) {
      showSpinner(null);
      setScene(segment);
    }
  }, [debugInfo, location.pathname, clips, spinVisible]);



  useEffect(() => {
    const el = wrapRef.current;
    if (!el) return;
    const calc = () => {
      const w = el.clientWidth || 0;
      const h = displayStyle === 'square' ? w : w / 2; // rectangle = 2:1
      setBoxH(h);
    };
    const ro = new ResizeObserver(calc);
    ro.observe(el);
    calc();
    return () => ro.disconnect();
  }, [displayStyle]);

  const frosted = {
    backdropFilter: 'blur(10px)',
    WebkitBackdropFilter: 'blur(10px)',
    background: 'rgba(0,0,0,0.35)',
    color: '#fff'
  };

const formatLoopName = (p) => {
  if (!p) return '—';
  const parts = p.split('/');
  const file = parts[parts.length - 1] || '';
  const base = file.replace(/\.[^/.]+$/, '');
  return base || '—';
};



  return (
    <>

      {/* <div
        ref={wrapRef}
        className={className }
        style={{ position: 'relative', zIndex: 1, margin: '0 0', ...style }}
      > */}
      {/* <div
        className={`${className || ''} ${
          displayStyle === 'square'
            ? 'video-menu-wrapper-square'
            : 'video-menu-wrapper-rectangle'
        }`}
        style={{ zIndex: 1, margin: '0 0', ...style }}
      > */}
      <div
        className={`${className || ''} video-menu-wrapper`}
        style={{ zIndex: 1, margin: '0 0', ...style }}
      >

      <VideoMenuUnderlay scene={scene} clips={clips} onLoopStart={hideSpinner} onDebugUpdate={setDebugInfo}  />
        {spinVisible && (
          <>
            {/* Center of window (change fixed→absolute if you want within container) */}
            {/* <img
              src={SPINNER_SRC}
              alt=""
              style={{
                position: 'fixed',              // change to 'absolute' if parent is position:relative
                left: '50%',
                top: '50%',
                transform: 'translate(-50%, -50%)',
                width: SPINNER_SIZE,
                height: SPINNER_SIZE,
                opacity: 0.9,

                pointerEvents: 'none',
                zIndex: 9999
              }}
            /> */}
            {/* On top of clicked button */}
            {spinAnchor && (
              <img
                src={SPINNER_SRC}
                alt=""
                style={{
                  position: 'fixed',            // change to 'absolute' if parent is position:relative
                  left: spinAnchor.left - SPINNER_SIZE / 2,
                  top:  spinAnchor.top  - SPINNER_SIZE / 2,
                  width: SPINNER_SIZE,
                  height: SPINNER_SIZE,
                  opacity: 0.9,
                  pointerEvents: 'none',
                  zIndex: 10000
                }}
              />
            )}
          </>
        )}
           {showControls == false && (
        <div style={{ position: 'relative', width: '100%', height: '100%', transition: 'height 320ms ease' }}></div>) }

           {showControls == true && (
        <div style={{ position: 'relative', width: '100%', height: '100%', transition: 'height 320ms ease' }}>
          {/* Top frosted bar: link-styled buttons */}
          
          <div className="mobile_header" style={{ ...frosted, position: 'absolute', top: 0, left: 0, right: 0, padding: '6px 10px' }}>
            <Stack direction="horizontal" gap={1} className="flex-wrap ">
              {(buttons || []).map((b, i) => (
                <Button
                  key={i}
                  variant="link"
                  className="text-white text-decoration-none px-1 btn-sm"
                  // onClick={() => setScene(b.targetScene)}
                  onClick={(e) => { 
                    if (debugInfo?.inTransit) {
                      navigate('/' + b.targetScene);   // already in transit → just update route
                      return;
                    }                    
                    else
                    { 
                      showSpinner(e.currentTarget); 
                      setScene(b.targetScene);
                      navigate('/'+b.targetScene)
                    }


                   }}
                  style={{ opacity: scene === b.targetScene ? 1 : 0.85 }}
                >
                  {b.label}
                </Button>
              ))}
            </Stack>
          </div>

          {/* Bottom frosted bar: current page/location */}
          <div style={{ ...frosted, position: 'absolute', bottom: 0, left: 0, right: 0, padding: '0px 0px',  }}>
            <div style={{ padding: '0px 0px', margin: '0px 0px',fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase' }}>
              {debugInfo && (
                <span style={{ fontSize: '0.6rem', marginLeft: 8, paddingBottom:'50px' }}>
                  {/* from: {debugInfo.from || '—'} */}
                 in: {debugInfo.currentLocation || '—'}
                  {/* {' | '}transit: {String(debugInfo.inTransit)} */}
                  {'   |  '}  moving: {' '} 
                  <span
                      style={{
                        color: debugInfo.inTransit ? 'yellow' : 'white',
                        fontSize: debugInfo.inTransit ? '0.8rem' : '0.6rem',
                        fontWeight: debugInfo.inTransit ? 700 : 400,
                        display: 'inline-flex',
                        alignItems: 'center',
                      }}
                    >
                      {String(debugInfo.inTransit)}
                      {debugInfo.inTransit && (
                        <img
                          src={SPINNER_SRC}
                          alt=""
                          style={{ width: 14, height: 14, marginLeft: 4 }}
                        />
                      )}
                    <br/>
                    </span>
                  {/* {' | '}anim: {formatLoopName(debugInfo.currentLoop)}                   */}
                  {/* {' | '}left: {debugInfo.segmentsLeft} */}
                </span>
              )}
            </div>



                  <div
                    className="d-flex justify-content-between align-items-center px-2 mx-0 py-1 my-1  bg-dark text-white"
                  >
                    <span className="text-white"   >
                    Learn how AI can help:
                    </span>
                    <Button
                      variant="danger"
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://calendly.com/justingirard/ai-art-chat"
                      style={{ padding: "0.3rem 0.6rem", fontSize: "0.85rem" }}
                    >
                      book
                    </Button>
                  </div>                          

          </div>






          {/* Middle layer remains pass-through so page stays clickable */}
          <div style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }} />
          
        </div>
           )}
           
      </div>
    </>
  );
}


